// What an add / edit form sends to the database.
// New record: only the fields that were filled in. Edit: every field that changed since the form opened,
// a cleared one ("— None —", emptied text or date) as null - otherwise the old value would stay.
const blank = v => v === undefined || v === null || v === ''
const same = (a, b) => (blank(a) && blank(b)) || (typeof a === 'object' || typeof b === 'object' ? JSON.stringify(a) === JSON.stringify(b) : String(a) === String(b))

export function formBody(fields, data, original) {
  const body = {}
  fields.forEach(f => {
    const v = data[f.name]
    if (!original) { if (!blank(v)) body[f.name] = v; return }
    if (same(v, original[f.name])) return
    body[f.name] = blank(v) ? null : v
  })
  return body
}
